module.exports = __webpack_public_path__ + "static/media/bryond profits-logo-02.d0fec753.webp";